import { useState, useEffect } from 'react';
import { Input } from '@/components/ui/input';
import { Popover, PopoverAnchor, PopoverContent } from '@/components/ui/popover';

// Searchable item typeahead (Vendor Bills, Vendor Credits, Transfer/Purchase Orders).
// The list renders in a portal so it is never clipped by scrolling tables/dialogs.
export default function ItemSearchPicker({ items, value, onPick, onType, testid, placeholder = 'Search item...' }) {
  const [q, setQ] = useState(value || '');
  const [open, setOpen] = useState(false);
  useEffect(() => { setQ(value || ''); }, [value]);

  const term = q.trim().toLowerCase();
  const filtered = term.length === 0
    ? items.slice(0, 60)
    : items.filter(i =>
        (i.name || '').toLowerCase().includes(term) ||
        (i.product_code || '').toLowerCase().includes(term) ||
        (i.sku || '').toLowerCase().includes(term)
      ).slice(0, 60);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverAnchor asChild>
        <Input
          value={q}
          onChange={e => { setQ(e.target.value); setOpen(true); if (onType) onType(e.target.value); }}
          onFocus={() => setOpen(true)}
          onBlur={() => setTimeout(() => setOpen(false), 150)}
          placeholder={placeholder}
          className="h-8 text-xs"
          data-testid={testid}
        />
      </PopoverAnchor>
      <PopoverContent
        align="start"
        className="p-0 w-[340px] max-w-[90vw]"
        onOpenAutoFocus={(e) => e.preventDefault()}
        onCloseAutoFocus={(e) => e.preventDefault()}
        onInteractOutside={(e) => { if (e.target?.closest?.(`[data-testid="${testid}"]`)) e.preventDefault(); }}
        data-testid={`${testid}-dropdown`}
      >
        <div onWheel={(e) => { e.currentTarget.scrollTop += e.deltaY; }} className="max-h-64 overflow-y-auto">
          {filtered.length === 0 ? (
            <div className="px-3 py-2 text-xs text-gray-400">No matching item</div>
          ) : filtered.map(item => (
            <button
              key={item.id}
              type="button"
              onMouseDown={(e) => { e.preventDefault(); onPick(item); setQ(item.name); setOpen(false); }}
              className="w-full text-left px-3 py-2 text-xs hover:bg-blue-50 border-b border-gray-100 last:border-0"
              data-testid={`${testid}-option-${item.id}`}
            >
              <span className="font-medium text-[#0B1B3D]">{item.name}</span>
              {(item.product_code || item.sku) && <span className="text-gray-400 ml-1">({item.product_code || item.sku})</span>}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
